import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { PasswordModule } from 'primeng/password';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { AuthService } from '../../services/auth/auth.service';

import { InputTextModule } from 'primeng/inputtext';
import { Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

export const StrongPasswordRegx: RegExp =
  /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: true,
  styles: [
    `
      :host ::ng-deep .pi-eye,
      :host ::ng-deep .pi-eye-slash {
        transform: scale(1.6);
        color: var(--primary-color) !important;
      }
    `,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    PasswordModule,
    ButtonModule,
    RippleModule,
    InputTextModule,
    ToastModule,
  ],
  providers: [MessageService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  private activatedRoute = inject(ActivatedRoute);
  private messageService = inject(MessageService);
  loginForm!: FormGroup;
  loading = false;
  errorMsg = signal<string>('');

  private router = inject(Router);
  subscription: Subscription = new Subscription();

  constructor() {}

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.queryParams['returnUrl']) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Could not delete account. You need to login first.',
      });
    }
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required]),
      password: new FormControl('', Validators.required),
    });
  }

  @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.login();
  }

  login() {
    if (!this.loginForm.valid) {
      return;
    }
    this.loading = true;
    if (this.errorMsg()) {
      this.errorMsg.set('');
    }
    this.subscription = this.authService
      .login(this.loginForm.value.email, this.loginForm.value.password)
      .subscribe({
        next: (response) => {
          this.loading = false;
          if (this.loginForm.value.email === 'cCenter') {
            this.router.navigateByUrl('/');
          } else {
            this.router.navigateByUrl(
              this.activatedRoute.snapshot.queryParams['returnUrl'] ||
                'delete-account'
            );
          }
        },
        error: (error) => {
          if (error.status === 404) {
            this.errorMsg.set('Δεν βρέθηκε χρήστης με αυτά τα στοιχεία.');
          } else if (error.status === 500) {
            this.errorMsg.set('Κάτι πήγε στραβά!');
          }
          this.loading = false;
        },
        complete: () => {},
      });
  }

  get passwordFormField() {
    return this.loginForm.get('password');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
